var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"float-right",on:{"click":_vm.handleClick}},[_vm._v("İstek Yap")])}
var staticRenderFns = []

export { render, staticRenderFns }